import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import DialogActions from "@mui/material/DialogActions";
import * as api from "../api/api";
import CloseIcon from "@mui/icons-material/Close";
import "reactjs-popup/dist/index.css";
import { Box } from "@mui/material";
import { StyledTextField } from "../components/StyledComponents/Inputs/Inputs.js";
import useAppContextProvider from "../AppContext/useAppContextProvider.js";
import PlaceHolderButton from "../components/PlaceHolderButton/PlaceHolderButton.js";
import { StyledDialog } from "../components/StyledComponents/Dialog/Dialog";
import {
  PrimaryButton,
  SecondaryButton,
  StyledIconButton,
} from "../components/StyledComponents/Buttons/AuradineButtons";
import {
  BodyMedium,
  H6HeadlineSmall,
  H8TitleMedium,
} from "../components/StyledComponents/Typography/Typography.tsx";
import { useTheme } from "../ThemeContext/ThemeContext.js"; 
export default function WhitelistDomainsDialog({
  setState,
  org,
  role,
}) {
  const { getAccessTokenSilently } = useAuth0();
  const { colors } = useTheme();
  const [open, setOpen] = React.useState(false);
  const [newDomain, setNewDomain] = React.useState("");
  const [domains, setDomains] = React.useState([]);
  const [error, setError] = React.useState({
    error: false,
    helperText: "",
  });
  const [domainFilled, setDomainFilled] =
    React.useState(false);
  const [domainValid, setDomainValid] =
    React.useState(false);
  const [domainDeleted, setDomainDeleted] =
    React.useState(false);
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();

  function isValidDomain(domain) {
    const pattern =
      /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.(?!-)[A-Za-z0-9-]{1,63}(?<!-))*\.[A-Za-z]{2,}$/;
    return pattern.test(domain);
  }

  const checkDomain = (value) => {
    const valid = isValidDomain(value);
    if (valid === false) {
      setError({
        error: true,
        helperText: "Invalid domain",
      });
      setDomainValid(false);
    } else {
      setError({ error: false, helperText: "" });
      setDomainValid(true);
    }
    return valid;
  };

  const addDomains = (newDomains) => {
    setDomains((prevDomains) => {
      const allDomains = new Set([
        ...prevDomains,
        ...newDomains,
      ]);
      return Array.from(allDomains);
    });
  };

  const handleDeleteDomain = (domainToDelete) => {
    setDomainDeleted(true);
    setDomains((prevDomains) =>
      prevDomains.filter(
        (domain) => domain !== domainToDelete
      )
    );
  };

  const handleInputChangeDomain = (event) => {
    const value = event.target.value;
    setNewDomain(value);
    setDomainFilled(value.trim() !== "");

    const valid = checkDomain(value);
    if (value.trim() !== "") {
      setDomainDeleted(false);
    } else {
      if (
        org.domains &&
        org.domains.length !== domains.length
      ) {
        setDomainDeleted(true);
      }
    }
  };

  React.useEffect(() => {
    if (
      org !== null &&
      org.hasOwnProperty("domains") &&
      org.domains &&
      org.domains.length > 0
    ) {
      addDomains(org.domains);
      setDomains(org.domains);
    } else if (
      org !== null &&
      org.hasOwnProperty("domains") &&
      org.domains &&
      org.domains.length === 0
    ) {
      setDomains([]);
    }
  }, [org]);

  React.useEffect(() => {
    if (domainFilled === false) {
      setError({ error: false, helperText: "" });
    }
  }, [domainFilled]);

  React.useEffect(() => {
    if (
      newDomain !== "" &&
      isValidDomain(newDomain) === false
    ) {
      setDomainDeleted(false);
    }
  }, [newDomain]);

  React.useEffect(() => {
    if (domains && domains.length >= 10) {
      setError({
        error: false,
        helperText:
          "A maximum of 10 domains can be added to the whitelist.",
      });
    } else {
      setError({ error: false, helperText: "" });
    }
  }, [domains]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDomainDeleted(false);
    setDomainFilled(false);
    setDomainValid(false);
    setNewDomain("");
    setDomains(org.domains);
  };

  const handleAddDomain = () => {
    if (newDomain.trim() !== "") {
      setDomains((prevDomains) => [
        ...prevDomains,
        newDomain.trim(),
      ]);
      setNewDomain("");
    }
  };

  const submitHandler = async (event) => {
    if (error.error) return;

    if (newDomain.trim() !== "") {
      setDomains((prevDomains) => {
        const allDomains = new Set([
          ...prevDomains,
          newDomain.trim(),
        ]);
        return Array.from(allDomains);
      });
    }
    let alldomains = domains;
    if (newDomain.trim() !== "") {
      const allDomains = new Set([
        ...domains,
        newDomain.trim(),
      ]);
      alldomains = Array.from(allDomains);
    }
    const fn = async () => {
      const token = await getAccessTokenSilently();
      let data = await api.PostDomains(token, alldomains);
      if (data.status === "ok") {
        setToastMessage(
          "Whitelists domain successfully updated."
        );
        setToastOpen(true);
      } else {
        if (
          data.hasOwnProperty("errorCode") &&
          data.errorCode === 1009
        ) {
          setToastMessage("Error:" + data.msg);
          setToastOpen(true);
        } else {
          setToastMessage("Error:" + data.msg);
          setToastOpen(true);
        }
      }
      setState((prevState) => !prevState);
      setOpen(false);
      setNewDomain("");
      setDomainDeleted(false);
      setDomainFilled(false);
      setDomainValid(false);
    };
    fn();
  };

  return (
    <div>
      <SecondaryButton colors={colors}
        disabled={role !== "superadmin"}
        onClick={handleClickOpen}
      >
        {" "}
        Whitelist Domains
      </SecondaryButton>
      <StyledDialog
        colors={colors}
        maxWidth="sm"
        sx={{ overflow: "hidden" }}
        open={open}
        onClose={handleClose}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          paddingTop={"1rem"}
          paddingBottom={"1rem"}
          gap={2}
        >
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            flexGrow={1}
          >
            <H6HeadlineSmall style={{ textAlign: "left" }}>
              Whitelist Domains
            </H6HeadlineSmall>
            <StyledIconButton onClick={handleClose} colors={colors}>
              <CloseIcon />
            </StyledIconButton>
          </Box>
          <BodyMedium style={{ textAlign: "left" }}>
            {" "}
            Whitelist domains define which email domains
            users in your organization are allowed to use
            when signing up for FluxVision.
          </BodyMedium>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"column"}
          flexShrink={0}
          gap={6}
          paddingBottom={"1rem"}
        >
          <StyledTextField colors={colors}
            autoFocus
            domain="domain"
            label="Add Domain"
            type="domain"
            size={"medium"}
            value={newDomain}
            fullWidth
            onChange={handleInputChangeDomain}
            error={error.error}
            helperText={error.helperText}
            disabled={domains && domains.length >= 10}
          />
          {domains && domains.length !== 0 && (
            <Box
              display={"flex"}
              flexDirection={"column"}
              flexShrink={0}
              gap={4}
            >
              <H8TitleMedium>
                Current Whitelist Domains:
              </H8TitleMedium>
              <Box
                display={"flex"}
                direction={"row"}
                flexGrow={1}
                flexWrap={"wrap"}
                gap={4}
                maxWidth={"40rem"}
                overflow={"auto"}
              >
                {domains.map((domain, index) => (
                  <PlaceHolderButton
                    key={index}
                    onClose={() =>
                      handleDeleteDomain(domain)
                    }
                    text={domain}
                  />
                ))}
              </Box>
            </Box>
          )}
        </Box>
        <DialogActions>
          <PrimaryButton colors={colors}
            onClick={() => {
              handleAddDomain();
              submitHandler();
            }}
            disabled={
              newDomain !== ""
                ? !domainValid
                : !domainDeleted
            }
          >
            Update
          </PrimaryButton>
        </DialogActions>
      </StyledDialog>
    </div>
  );
}
